import { withTheme } from "@emotion/react";
import CITFormGroup from "../../../../Form/CITFormGroup";
import { Typography, Box, Stack } from "@mui/material";
import * as React from 'react';
import FileInput from "../../../../Form/FileInput";
import DateInput from "../../../../Form/DateInput";
import TextInput from "../../../../Form/TextInput";


const ReferenceRelease = (props) => {


    const theme = props.theme

    return (

        <Box width={'inherit'}>
            <Stack mx={{ xs: '19px', sm: '60px', md: '85px' }} justifyContent={'space-around'} mt={'24px'} >
                <Typography width={{ sm: '668px', md: '998px' }} mt={'48px'} sx={{ ...theme.typography.heading, fontSize: { xs: '18px', sm: '20px', md: '29px' } }} gutterBottom>
                    {'REFERENCE RELEASE FORM'}
                </Typography>
            </Stack>
               <CITFormGroup mt={'-16px'} direction={'column'}>
                     <CITFormGroup mt={'24px'} mx={'0px'} width={'100%'}>
                        <TextInput textLable={'Applicant name'} placeholder={'Your response'} boxWidth={'100%'} inputWidth={'inherit'} />
                        <DateInput boxWidth={'100%'} inputWidth={'inherit'} dateLable={'Date'} />
                    </CITFormGroup>
                    <Typography mb={'24px'} sx={theme.typography.body} gutterBottom>
                        I consent to and authorize the former employers listed below, and its agents and employees, to furnish any reference
                        information concerning me, including achievement, wage history, performance, attendance, personal
                        history, disciplinary
                        information and reason for separation of employment, relating to my employment with the
                        former employee. It is
                        expressly understood that any information given is to be used for the purpose of determining
                        acceptability for
                        employment. I also hereby release the former employers listed below, and its agents and 
                        employees, from all liability for
                        damages or claims, including but not limited to defamation, interference with 
                        contract, or prospective economic advantage
                        and negligence, I have or may have which arise or result from any 
                        reference information provided pursuant to this
                        authorization or any attempts to comply with this information.
                </Typography>
                <TextInput mt='24px' textLable={'Employer name'} placeholder={'Your response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <CITFormGroup mt={'24px'} mx={'0px'} width={'100%'}>
                        <TextInput textLable={'Applicant name'} placeholder={'Your response'} boxWidth={'100%'} inputWidth={'inherit'} />
                        <DateInput boxWidth={'100%'} inputWidth={'inherit'} dateLable={'Date'} />
                </CITFormGroup>
                <TextInput mt='24px' textLable={'Employer name'} placeholder={'Your response'} boxWidth={'100%'} inputWidth={'inherit'} />
                <CITFormGroup mt={'24px'} mx={'0px'} width={'100%'}>
                        <TextInput textLable={'Applicant name'} placeholder={'Your response'} boxWidth={'100%'} inputWidth={'inherit'} />
                        <DateInput boxWidth={'100%'} inputWidth={'inherit'} dateLable={'Date'} />
                </CITFormGroup>
                <FileInput showImage title="Add File" fileLable={'Your signature'} />
    
                </CITFormGroup>
    


        </Box>



    )
}

export default withTheme(ReferenceRelease);